/** Web Push VAPID public key (safe to expose in the client). */
export const VAPID_PUBLIC_KEY = 'BFCt8U8Q0gelXVqlYYvKapZ31fZl1G992qAsTQedWWlxPMsYlRlSdEEp_GXvo08Ds1BHgta88QrOpL66oNNp728';
